import { useMemo } from "react";
export const useBrowserContext = () => {
    const isLocalhost = useMemo(() => window.location.hostname.includes("localhost"), [window.location.hostname]);
    const isAdminApp = useMemo(() => window.location.hostname.includes("admin.therapprove.com"), [window.location.hostname]);
    const isOrganizationApp = useMemo(() => window.location.hostname.includes("org.therapprove.com") ||
        window.location.hostname.includes("organization.therapprove.com"), [window.location.hostname]);
    return {
        isLocalhost: !!isLocalhost,
        isAdminApp: !!isAdminApp,
        isOrganizationApp: !!isOrganizationApp
    };
};
